import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

const ChevronDownIcon = (props: SvgIconProps) => {
    return (
        <SvgIcon viewBox="0 0 25 25" {...props}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M5.21623 8.90004C5.60676 8.50952 6.23992 8.50952 6.63045 8.90004L12.9233 15.1929L19.2162 8.90004C19.6068 8.50952 20.2399 8.50952 20.6304 8.90004C21.021 9.29056 21.021 9.92373 20.6304 10.3143L13.6304 17.3143C13.2399 17.7048 12.6068 17.7048 12.2162 17.3143L5.21623 10.3143C4.82571 9.92373 4.82571 9.29056 5.21623 8.90004Z"
            />
        </SvgIcon>
    );
};

export default ChevronDownIcon;
